import React, { useState } from "react";
import { useLsp } from "../store/LspContext";
import { apiRepaymentSchedule } from "../api/lspApi";

export default function RepaymentSchedulePage() {
    const { state } = useLsp();
    const [startDate, setStartDate] = useState("23-March-2025");
    const [out, setOut] = useState("");
    const [loading, setLoading] = useState(false);

    const run = async () => {
        setLoading(true); setOut("");
        try {
            const res = await apiRepaymentSchedule(state.baseUrl, state.token, state.partnerLoanId, startDate);
            setOut(JSON.stringify(res, null, 2));
        } catch (e) {
            setOut("❌ " + e.message);
        } finally { setLoading(false); }
    };

    return (
        <div style={card}>
            <h2 style={h2}>4) Get Expected Repayment Schedule</h2>
            <input style={inp} value={startDate} onChange={(e) => setStartDate(e.target.value)} placeholder="23-March-2025" />
            <button style={btn} onClick={run} disabled={loading || !state.token || !state.partnerLoanId}>
                Get Schedule
            </button>
            <pre style={pre}>{loading ? "⏳ loading..." : out || "No response yet"}</pre>
        </div>
    );
}
const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "#0f172a" };
const h2 = { marginTop: 0 };
const inp = { marginRight: 10, padding: 10, borderRadius: 10, border: "1px solid #334155", background: "#fffff", color: "#e5e7eb", width: 240 };
const btn = { padding: "10px 14px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer" };
const pre = { marginTop: 12, background: "#fffff", border: "1px solid #334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: 360 };
